import React from 'react'
import { DropdownButton } from 'components'
import { _ } from 'utils'

interface Props {
    showProgramContainerModal: () => void
    createProgram: () => void
}

const AddDropdownButton = ({
    showProgramContainerModal, createProgram
}: Props) => (
    <DropdownButton name={_('button.add')} variant="primary" icon="plusBox" className="ml-2">
        <div onClick={() => showProgramContainerModal()}>
            {_('show.list.add_parent')}
        </div>
        <div onClick={createProgram}>
            {_('show.list.add_item')}
        </div>
    </DropdownButton>
)

export default AddDropdownButton
